export enum PortState {
  disconnected,
  connecting,
  connected,
}
